import { render } from "./TaxToolTip.vue?vue&type=template&id=6d814ccc"
import script from "./TaxToolTip.vue?vue&type=script&lang=js"
export * from "./TaxToolTip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__